// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// ** Axios Imports
import axios from "axios";

export const getQuestions = createAsyncThunk(
  "appQuestions/getQuestions",
  async (params) => {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_API_URL}/api/account/getAllUsers`,
      params
    );
    return {
      params,
      data: response.data.users,
      allData: response.data.users,
      totalPages: response.data.total,
    };
  }
);

export const appQuestionsSlice = createSlice({
  name: "appQuestions",
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getQuestions.fulfilled, (state, action) => {
      state.data = action.payload.data;
      state.allData = action.payload.data;
      state.total = action.payload.totalPages;
      state.params = action.payload.params;
    });
  },
});

export default appQuestionsSlice.reducer;
